<template>
  <div class="flex column" v-title data-title="关于阅伴" style="background-color:#F9FBF7FF">
    <div class="flex main-space-between cross-center" style="margin-top: 28px; margin-left: 33px; margin-right: 33px">
      <img src="../assets/about_yueban_left.png" width="14" height="14">
      <div style="color: #21BEA1FF; font-size: 20px; font-weight: bolder">阅伴</div>
      <img src="../assets/about_yueban_right.png" width="14" height="14">
    </div>
    <div style="margin: 20px 33px 0">
      <p>我们是一个增强阅读趣味性的APP</p>
      <p>我们有学生端，教师端，以及家长服务端</p>
      <p>可以涵盖全国中小学生和教师们使用</p>
      <p>选择好书，分级阅读，效果可见</p>
      <p>促进学生读书兴趣，优化教师班级管理</p>
      <p>*&nbsp;我们做老师的强大助手，让老师的身心和体力得到解放，更加专注于教学与创新！</p>
      <p>*&nbsp;我们帮助学生增强阅读趣味性，以游戏闯关做“桥梁”，摆脱学习枯燥形式，提升学生阅读兴趣，促进学习主动性。</p>
      <p>*&nbsp;我们帮助家长可直接关注学生自主阅读中的效果与进度，同步提供家长在家庭阅读中优质的的科学内容与方法，让亲子共读成效更加显著，并与您并肩作战！</p>
      <p>*&nbsp;当我遇上全国优秀的语文教师们，我融入你们，成为了我们，我们共同的愿景是让学生爱上阅读，让阅读更有趣！</p>
    </div>
    <div style="margin: 30px 33px 0; color: #6D8179FF">
      功能彩蛋：<br>
      <p style="margin-top: 5px">1.班级便管理-不限学生人数，导、读、测、评功能实用性高。</p>
      <p>2.共读易组织-自动化在线组织阅读，节约更多教学精力。</p>
      <p>3.书单更合理-手指轻点发布，品质童书任你挑。</p>
      <p>4.成绩有榜单-阅读字数、闯关正确率、平均用时等，均可查看每位学生详细数据。</p>
      <p>5.一键催进度-理想的阅读教学催促和点赞环境，协助您的教学管理。</p>
      <p>6.数据有存储-班级阅读情况有存储，随时勘察更方便。老师阅读教学的付出与班级阅读数据“同转化”。</p>
    </div>
    <div class="flex main-center cross-center" style="margin-top: 35px; margin-bottom: 29px">
      <img src="../assets/bottom_logo.png" width="265" height="51">
    </div>
  </div>
</template>

<script>

    export default {
      name: "AboutYueban",
      beforeCreate () {
        // document.querySelector('body').setAttribute('style', 'background-color:#F9FBF7FF; margin: 0; padding: 0; height: auto')
      }
    }

</script>

<style scoped>
  p{
    margin: 0px;
    padding: 0;
    color: #6D8179FF;
    font-size: calc(13.5 / 375 * 100vw);
    line-height: calc(23 / 375 * 100vw);
    font-family: PingFang-Regular;
  }
</style>



// WEBPACK FOOTER //
// src/components/AboutYueban.vue